import { forwardRef } from 'react';
import { BoxOptions, BoxProps } from '../Box/Box';
import { ProgressBarField } from './components/ProgressBarField';
import { ProgressBarWrapper } from './components/ProgressBarWrapper';

export type ProgressBarProps = Omit<
  BoxOptions,
  | 'borderRadius'
  | 'bg'
  | 'backgroundColor'
  | 'p'
  | 'px'
  | 'py'
  | 'pl'
  | 'pr'
  | 'pt'
  | 'pb'
  | 'padding'
  | 'paddingBottom'
  | 'paddingTop'
  | 'paddingLeft'
  | 'paddingRight'
  | 'paddingX'
  | 'paddingY'
  | 'height'
> & {
  value: 'ZeroStep' | 'ConfirmStep' | `${number}%` | number;
};

export const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(
  ({ value = 0, ...rest }, ref) => {
    let width: BoxProps['width'] = value;
    if (value === 'ZeroStep') width = '20px';
    if (value === 'ConfirmStep') width = 'calc(100% - 20px)';
    return (
      <ProgressBarWrapper ref={ref} {...rest}>
        <ProgressBarField width={width} />
      </ProgressBarWrapper>
    );
  }
);
